import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { contactRecordQuery } from "@/app/Contacts/GraphQL/contactRecordQuery";
import { createEntityMutation } from "@/app/Contacts/GraphQL/contactMutations";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";

export function ContactEntityCreateDialog({
  contactId,
  initialValues,
}: {
  contactId: string;
  initialValues?: any;
}) {
  const { data } = useSuspenseGqlQuery(contactRecordQuery, {
    id: contactId,
  });

  const { mutateAsync } = useGqlMutation(createEntityMutation);

  const { close } = useDialogState();
  const { contact } = data;

  return (
    <BaseDialog title={"Create Entity"}>
      <GenericForm<{
        name: string;
      }>
        initialValues={{
          name: contact.name ?? "",
          ...initialValues,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            contactId,
            input: {
              name: values.name,
            },
          });

          close();
        }}
      >
        <TextInput name="Name" label="Entity Name" className="col-span-6" />
        <DialogSubmitButton text={"Create Entity"} />
      </GenericForm>
    </BaseDialog>
  );
}
